import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import Promise from 'bluebird';

const applications = [
  ['activation-app', () => import ('./App')],
]

const renderApp = async ([id, loader]) => {
  var target = document.getElementById(id);

  if (target) {
    var module = await loader();
    var App = module.default;
    var root = createRoot(target);

    root.render(<App />);
    return true;
  }

  return false;
}

try {
Promise.map( applications, renderApp).then( (loaded) => {
  if (loaded.some( (x) => x )) {
    // The portal no longer uses a service worker. An old Workbox one, still
    // installed in returning visitors' browsers, answered every navigation with
    // a stale precached index.html; public/service-worker.js now replaces it
    // with a worker that removes itself, and this drops any registration that
    // survives. Only the root registration is touched -- /app/ belongs to the
    // OrionNt web app and its own worker.
    unregisterServiceWorker();
  }
});
} catch (error) {
  var message=error.message();
}


